export default {
  title: 'Masks',
  name: 'Name',
  pattern: 'Mask',
  enabled: 'Enabled'
}
